import { object, string } from "yup";

export const NewRoleSchema = object({
  name: string().required("Задолжително"),
});
